import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  QueryList,
  ViewChildren,
  ElementRef,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-otp-input',
  templateUrl: './otp-input.component.html',
  styleUrls: ['./otp-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OtpInputComponent),
      multi: true,
    },
  ],
})
export class OtpInputComponent implements OnInit, ControlValueAccessor {
  @Input() length = 6;
  @Output() otpChange = new EventEmitter<string>();

  value: string = '';
  onChange: any = () => {};
  onTouched: any = () => {};

  @ViewChildren('otpInput') otpInputs?: QueryList<ElementRef>;

  public inputs?: any[];

  ngOnInit() {
    this.inputs = new Array(this.length);
  }

  writeValue(value: string): void {
    this.value = value || '';
    // atualizar visual
    setTimeout(() => {
      if (this.otpInputs) {
        const chars = this.value.split('');
        this.otpInputs.toArray().forEach((el, idx) => {
          el.nativeElement.value = chars[idx] || '';
        });
      }
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onKeyUp(event: any, index: number) {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;

    // 1. Regex para verificar se o valor é um único dígito numérico
    if (!/^[0-9]$/.test(inputValue)) {
      // 2. Se não for um número, limpa o campo imediatamente
      inputElement.value = '';
      return; // Interrompe a execução para este evento
    }

    // 3. Se for um número, move o foco para o próximo campo (se houver)
    if (index < this.length - 1) {
      this.otpInputs?.toArray()[index + 1].nativeElement.focus();
    }

    // 4. Emite o valor completo do OTP
    this.emitOtp();
  }

  // O método onKeyDown pode permanecer o mesmo para lidar com o Backspace
  onKeyDown(event: any, index: number) {
    if (event.key === 'Backspace' && event.target.value.length === 0) {
      if (index > 0) {
        this.otpInputs?.toArray()[index - 1].nativeElement.focus();
      }
    }
  }

  onPaste(event: ClipboardEvent, index: number) {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text').trim() ?? '';

    // Garante que só aceita números
    if (!/^[0-9]+$/.test(pastedData)) {
      return;
    }

    // Atualiza o valor interno completo
    const otpArray = this.value.split('');
    for (let i = 0; i < this.length && i < pastedData.length; i++) {
      otpArray[index + i] = pastedData[i];
    }

    // Atualiza o estado interno e o visual
    this.value = otpArray.join('');
    this.handleInputChange(this.value);
    this.writeValue(this.value);

    // Move o foco para o último campo preenchido
    const lastIndex = Math.min(index + pastedData.length - 1, this.length - 1);
    this.otpInputs?.toArray()[lastIndex].nativeElement.focus();
  }

  private emitOtp() {
    const otpValue = this.otpInputs
      ?.toArray()
      .map((el) => el.nativeElement.value)
      .join('');
    this.otpChange.emit(otpValue);
  }

  handleInputChange(value: string) {
    this.value = value;
    this.onChange(this.value); // notifica o form control
    this.onTouched();
  }

  onInput(event: any, idx: number) {
    const val = event.target.value;
    let chars = this.value.split('');
    chars[idx] = val;
    this.handleInputChange(chars.join(''));
  }
}
